// Shared scroll-spy + the ONE docs anchor offset.
// DOCS_ANCHOR_OFFSET is the single scroll-offset constant for ALL docs anchors:
// it matches shell.tsx's reused DocSection `scrollMarginTop: 110` and is used by
// both the right-rail "On this page" click handler and any in-page TOC jump.
import { useEffect, useState } from 'react';

export const DOCS_ANCHOR_OFFSET = 110;

// Returns the id of the section currently in view (last section whose top has
// crossed ~35% of the viewport). Pattern lifted from the old docs.tsx scrollspy.
export function useScrollSpy(ids: string[]): string {
  const [active, setActive] = useState<string>(ids[0] ?? '');
  const key = ids.join('|');
  useEffect(() => {
    if (!ids.length) return;
    const onScroll = () => {
      let cur = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top < window.innerHeight * 0.35) cur = id;
      }
      setActive(cur);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return active;
}
